import React from 'react';

import { BaseIcon } from 'components';

export const PencilIcon = (props) => {
  return (
    <BaseIcon props={props} className={`pencil-icon ${props.className || ''}`}>
      <svg width="21" height="21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill="#555" fillRule="evenodd" clipRule="evenodd" d="M13.5 3.47L16.19.78c.431-.43 1.13-.43 1.56 0l2.418 2.417c.43.43.43 1.13 0 1.56l-2.69 2.69L13.5 3.47zm2.34 0l1.637 1.638 1.131-1.131-1.637-1.638L15.84 3.47zM6.762 18.162l-4.78.79.865-4.829 9.48-9.479 3.976 3.977-9.54 9.541zM4.49 14.821l-.02-.02-.36 2.057 2.037-.38-.02-.02 7.838-7.837-1.638-1.637L4.49 14.82z" />
      </svg>
    </BaseIcon>
  );
};
